// Вопрос «да / нет» из кода без React (транспорт api()). Показывает его
// ConfirmHost, стоящий в корневом layout; пока хоста нет — родной confirm.

type Ask = { text: string; resolve: (ok: boolean) => void };
let listener: ((a: Ask) => void) | null = null;

export function setConfirmListener(fn: ((a: Ask) => void) | null): void {
  listener = fn;
}

export function askConfirm(text: string): Promise<boolean> {
  if (typeof window === "undefined") return Promise.resolve(false);
  if (!listener) return Promise.resolve(window.confirm(text));
  return new Promise((resolve) => listener!({ text, resolve }));
}
